import { render, staticRenderFns } from "./MbStudentList.vue?vue&type=template&id=2c788ea3&"
import script from "./MbStudentList.vue?vue&type=script&lang=js&"
export * from "./MbStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports